/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseCatalogConfig } from '../../models/api-response-catalog-config';

export interface GetCatalogConfig$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getCatalogConfig(http: HttpClient, rootUrl: string, params: GetCatalogConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseCatalogConfig>> {
  const rb = new RequestBuilder(rootUrl, getCatalogConfig.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseCatalogConfig>;
    })
  );
}

getCatalogConfig.PATH = '/v1/api/ui/company/catalog-config';
